/**
 * getPrerollConfigByEdition - Returns the proper edition prerollConfig object from the external `app-configurations`
 * JSON; defaults to an empty object for easier destructuring.
 *
 * @param {string} edition - edition obtained from editionSelector()
 * @param {object} prerollConfig = {} - External app-configurations prerollConfig object supporting
 * multiple editions
 *
 * @return {object} - Config object containing contentType rules (`intervals`, `savePrerollHistory`)
 */
export default function getPrerollConfigByEdition(edition, prerollConfig = {}) {
    // catches null or undefined
    if (!edition || !prerollConfig) {
        return {};
    }

    if (prerollConfig && prerollConfig[edition] && prerollConfig[edition].contentTypeRules) {
        return prerollConfig[edition].contentTypeRules;
    }

    return {};
}



// WEBPACK FOOTER //
// ./app/lib/util/getPrerollConfigByEdition.js